<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.08.08h19.84v19.84H.08V.08z" />
    <path
      d="M15.836 4.161a8.224 8.224 0 00-5.837-2.427c-4.567 0-8.256 3.699-8.256 8.266s3.689 8.266 8.256 8.266c3.853 0 7.066-2.634 7.986-6.199h-2.15A6.189 6.189 0 0110 16.2c-3.422 0-6.2-2.78-6.2-6.2s2.778-6.2 6.2-6.2c1.714 0 3.244.713 4.36 1.84L11.03 8.967h7.234V1.734l-2.43 2.426v.001z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
